import * as Yup from 'yup';
export const stockGroupValidationSchema = Yup.object().shape({
  groupName: Yup.string().required('Stock Group Name is required').min(3, 'Enter a valid group name'),
  stocks: Yup.array().min(1, 'Please select at least select one stock').required('Stocks is required')
});

export const getConfigValidationSchema = (type: 'sector' | 'fund') => {
  if (type === 'sector') {
    return Yup.object().shape({
      sectorName: Yup.string().required('Sector Name is required').min(3, 'Enter a valid Sector Name')
    });
  } else {
    return Yup.object().shape({
      fundName: Yup.string().required('Fund Name is required').min(3, 'Enter a valid Fund Name')
    });
  }
};

export const addValidation = Yup.object().shape({
  firstName: Yup.string().required('First name is required').min(3, 'Enter a valid first name'),
  lastName: Yup.string().required('Last name is required').min(1, 'Enter a valid last name'),
  email: Yup.string()
    .required('Email is required')
    .email('Enter a valid email address')
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Enter a valid email address'),
  password: Yup.string().when([], (password, schema) =>
    password
      ? schema
          .required('Password is required')
          .min(6, 'Password must be at least 6 characters long')
          .matches(/[A-Z]/, 'Password must contain at least one uppercase letter') // At least one uppercase letter
          .matches(/[a-z]/, 'Password must contain at least one lowercase letter') // At least one lowercase letter
          .matches(/[\W_]/, 'Password must contain at least one special character') // At least one special character
      : schema
  ),
  confirm: Yup.string().when('password', (password, schema) =>
    password ? schema.required('Confirm Password is required').oneOf([Yup.ref('password')], 'Passwords must match') : schema
  ),
  roleId: Yup.string().required('Role is required'),
  department: Yup.string().required('Department is required').min(1, 'Enter a valid department')
});

export const updateValidation = Yup.object().shape({
  firstName: Yup.string().required('First name is required').min(3, 'Enter a valid first name'),
  lastName: Yup.string().required('Last name is required').min(1, 'Enter a valid last name'),
  email: Yup.string()
    .required('Email is required')
    .email('Enter a valid email address')
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Enter a valid email address'),
  roleId: Yup.string().required('Role is required'),
  department: Yup.string().required('Department is required').min(1, 'Enter a valid department')
});



